export { default } from './ViewInStoplist';
